let $ = require( "jquery" );

$(function() {

    if($('.account-cart-page').length)  {

        $('.cart-item-container').each(function () {

            let quantityInput = $(this).find('.quantity-input'),
                quantityIncrement = $(this).find('.quantity-increment'),
                quantityDecrement = $(this).find('.quantity-decrement'),
                RemoveItem = $(this).find('.cart-remove-button');

            // RemoveItem.on('click',function(e){
            //     e.preventDefault();
            //     var id = $(this).data('id');
            //     AddRemove(id , 0);
            // })    
            // quantityIncrement.on('click', function () {
            //     let currentVal = parseInt(quantityInput.val());
            //     quantityInput.val(currentVal + 1);
            //     checkQtyOptions();
            //     var id = $(this).data('id'),
            //         qty = parseInt(currentVal + 1);
            //     AddRemove(id , qty);
            //     // $('#cart-update-button').click();
            // });

            // quantityDecrement.on('click', function () {
            //     let currentVal = parseInt(quantityInput.val());
            //     if(currentVal > 1) {
            //         quantityInput.val(currentVal - 1);
            //     }
            //     checkQtyOptions();
            //     var id = $(this).data('id'),
            //         qty = currentVal - 1;
            //     if(qty > 1){    
            //      AddRemove(id , qty);
            //     }
            //     // $('#cart-update-button').click();
            // });

            
            // function checkQtyOptions() {
            //     let qty = parseInt(quantityInput.val());
            //     if(qty > 1) {
            //         quantityDecrement.removeClass('disabled');
            //     } else {
            //         quantityDecrement.addClass('disabled');
            //     }
            // }
            // checkQtyOptions();

        });
        $('body').on('click','.quantity-increment',function(){
            
            let currentVal = parseInt($(this).siblings('.quantity-input').val());
            $(this).siblings('.quantity-input').val(currentVal + 1);
            // checkQtyOptions();
            var id = $(this).data('id'),
                qty = parseInt(currentVal + 1);
            AddRemove(id , qty);
        })
        $('body').on('click','.quantity-decrement',function(){
            let currentVal = parseInt($(this).siblings('.quantity-input').val());
            // checkQtyOptions();
            var id = $(this).data('id'),
            qty = parseInt(currentVal - 1);
                if(qty > 0) {
                 $(this).removeClass('disabled');
                  $(this).siblings('.quantity-input').val(currentVal - 1);
                  AddRemove(id , qty);
                }else{
                    $(this).addClass('disabled');
                }
        })
        $('body').on('click','.cart-remove-button',function(e){
            e.preventDefault();
            var id = $(this).data('id');
            AddRemove(id , 0);
        })
        function AddRemove(id , qty){
             var addData = {'id':id.toString(), 'quantity':qty};
            //   console.log('addData',addData, typeof(addData))
              fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'xmlhttprequest',
                },
                credentials: 'same-origin',
                body: JSON.stringify(addData),
              }).then(function(response) {
                return response.json();
              }).then(function(json) {
                $.ajax({
                    type: "GET",
                    url: "/cart.js",
                    dataType: "json",
                    success: function (cart) {
                      // Trigger the custom event 'AjaxAdded' with the updated cart data
                      $('.cart-count').text(cart.item_count)
                      $(document).trigger("AjaxAdded", [cart]);
                    },
                    error: function (err) {
                      console.log("Error fetching cart data:", err);
                    }
                  });
              }).catch(function(err) {
                console.error(err)
              });
        }

        // async function AddRemove(id, qty) {
        //     console.log('qty',id, qty);
            
        //     const addData = {
        //       'id': id, 
        //       'quantity': qty,
        //     };
          
        //     try {
        //       const response = await fetch('/cart/update.js', {
        //         method: 'POST',
        //         headers: {
        //           'Content-Type': 'application/json',
        //           'X-Requested-With': 'xmlhttprequest',
        //         },
        //         credentials: 'same-origin',
        //         body: JSON.stringify(addData),
        //       });
          
        //       if (!response.ok) {
        //         throw new Error(`HTTP error! status: ${response.status}`);
        //       }
          
        //       const json = await response.json();
        //       console.log('cart updated', json);
        //     } catch (error) {
        //       console.error('Failed to update cart:', error);
        //     }
        //   }
          

    }

});
